<template>
  <div>
    <b-alert
      variant="success"
      :show="showAlert_success"
      @dismissed="showAlert_success = false"
      >{{ alert_success_message }}</b-alert
    >

    <b-alert
      variant="danger"
      :show="showAlert_error"
      @dismissed="showAlert_error = false"
      >{{ alert_error_message }}</b-alert
    >

    <b-container fluid>
      <h3 class="mt-3 mb-3">Stock Take Job / Product</h3>

      <!-- <b-table
        v-if="dashboard_view_mode"
        small
        outlined
        striped
        hover
        :items="actual_items"
        :fields="location_fields"
      > -->
      <b-table
        small
        outlined
        striped
        hover
        :items="actual_items"
        :fields="location_fields"
      >
      </b-table>

      <!-- <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="TABLE_LIMIT"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination> -->
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";
import apiService from "../services/ApiService";
import global_function from "../mixins/global_function";

const fields = [
  {
    key: "product_sku",
    label: "Product SKU",
  },
  {
    key: "product_description",
    label: "Product Description",
    class: "width_350"
  },
  {
    key: "expected_qty",
    label: "Expected Qty",
    class: "center_align",
  },
  {
    key: "actual_qty",
    label: "Actual Qty",
    class: "center_align",
  },
  {
    key: "discrepancy",
    label: "Discrepancy",
    class: "center_align",
  },
];

const location_fields = [
  {
    key: "product_sku",
    label: "Product SKU",
  },
  {
    key: "actual_location",
    label: "Actual Location",
  },
  {
    key: "actual_qty",
    label: "Actual Qty",
  },
  {
    key: "status",
    label: "Status",
  },
  {
    key: "remark",
    label: "Remark",
  },
  {
    key: "start_at",
    label: "Start at",
  },
  {
    key: "completed_at",
    label: "Completed at",
  },
  {
    key: "by User",
    label: "By User",
  },
];

export default {
  name: "StockTakeJob",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
  components: {
    barcode: VueBarcode,
  },
  mixins: [apiService, global_function],
  data() {
    return {
      dashboard_view_mode: false,
      upload_file: null,
      loader_full: false,
      loader: false,
      items: [],
      fields: fields,
      actual_items: [],
      location_fields: location_fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      search_criteria: {
        keyword: "",
        discrepancy: 0,
        discrepancy_type_selected: "All (Act - Exp)",
        status_selected: "Completed",
      },
      status_options: [
        {
          value: "Completed",
          text: "Completed",
        },
        {
          value: "In-Progress",
          text: "In-Progress",
        },
        {
          value: "Pause",
          text: "Pause",
        },
      ],
      discrepancy_type_options: [
        {
          value: "All (Act - Exp)",
          text: "All (Act - Exp)",
        },
        {
          value: "> 0",
          text: "> 0",
        },
        {
          value: "= 0",
          text: "= 0",
        },
        {
          value: "< 0",
          text: "< 0",
        },
      ],
      showAlert_success: false,
      alert_success_message: "",

      showAlert_error: false,
      alert_error_message: "",
    };
  },
  async created() {
    await this.getStockTakeJob();
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false,
    });
  },
  methods: {
    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    exportCSV() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      this.$http({
        url: this.NODEJS_API_URL + "/gen_excel",
        method: "POST",
        data: {
          export_type: "stock_take_job_product",
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "stock_take_job_product.xlsx");
        document.body.appendChild(link);
        link.click();

        this.loader.hide();
      });
    },

    exportCSVLocation() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      this.$http({
        url: this.NODEJS_API_URL + "/gen_excel",
        method: "POST",
        data: {
          export_type: "stock_take_job_product_location",
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "stock_take_job_location.xlsx");
        document.body.appendChild(link);
        link.click();

        this.loader.hide();
      });
    },

    exportCSVFull() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      this.$http({
        url: this.NODEJS_API_URL + "/gen_excel",
        method: "POST",
        data: {
          export_type: "stock_take_job_product_full",
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "stock_take_job_full.xlsx");
        document.body.appendChild(link);
        link.click();

        this.loader.hide();
      });
    },

    exportCSVActual() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      this.$http({
        url: this.NODEJS_API_URL + "/gen_excel",
        method: "POST",
        data: {
          export_type: "stock_take_job_product_actual",
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "stock_take_job_actual.xlsx");
        document.body.appendChild(link);
        link.click();

        this.loader.hide();
      });
    },

    async getStockTakeJob() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "stock_take_job_product_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
          product_sku: this.$route.params.product_sku,
        },
      });
      this.items = response.data.stj;
      this.actual_items = response.data.stj_actual;
      this.total_rows = parseInt(response.data.total_rows_actual);
      this.loader.hide();
    },

    onSearch() {
      for (const key in this.search_criteria) {
        if (typeof this.search_criteria[key] === "string") {
          this.search_criteria[key] = this.search_criteria[key].trim();
        }
      }
      this.getStockTakeJob();
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.TABLE_LIMIT;
      this.getStockTakeJob();
    },

    async onUploadFile() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let formData = new FormData();
      formData.append("excel_file", this.upload_file);
      formData.append("user_id", this.$store.state.user_obj.user_id);
      formData.append("client_id", this.$store.state.user_obj.client_id);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "stock_take_job_import.php",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      });

      if (response) {
        this.loader_full.hide();
        if (response.data.status == "success") {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Upload Success",
          });
        } else {
          this.$eventHub.$emit("show_modal_message", {
            message_content: response.data.error_msg,
          });
        }
        this.getStockTakeJob();
      }
    },
  },
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.dot_container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.dot_status {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #00e570;
  margin-top: 5px;
}

.dot_status.red_light {
  background-color: #db5252;
}

.dot_status.yellow_light {
  background-color: #ffd700;
}

.width_350{
  width: 350px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/StockTakeJobProduct.vue